/**
* Is a given variable undefined or equal to null
* @param {obj} object
*/
const isNullOrUndefined = (obj) => {
  return isNull(obj) || isUndefined(obj)
}

const isEmpty = (obj) => {
  return isNull(obj) || isUndefined(obj) || obj === ''
}

/**
* Is a given variable equal to null
* @param {obj} object
*/
const isNull = (obj) => {
  return obj === null
}

/**
* Is a given variable undefined
* @param {obj} object
*/
const isUndefined = (obj) => {
  return obj === void 0
}

/**
* Returns true if any keys are set on the object
* @param {obj} object
*/
const objectHasKeys = (obj) => {
  if (!obj) {
    return false
  }
  return !isNullOrUndefined(obj) && Object.keys(obj).length > 0
}

export {
  isNullOrUndefined,
  isEmpty,
  isNull,
  isUndefined,
  objectHasKeys
}



// WEBPACK FOOTER //
// ./src/utils/comparators.js